/**
 * Csoport CRUD wrapper a FE-n.
 *
 * - `createGroup` / `updateGroup` mutáló műveletek: a free_text + institution-bound
 *   flow-t a BE szerint indítja (refine a Zod-on).
 * - `fetchGroupTypes` / `fetchSchoolYears` / `searchInstitutionsForCountry` a
 *   csoport-létrehozás wizard-jához.
 *
 * A `fetchInstitution` (core-entities) és a `fetchMyGroups` (me) máshol vannak.
 */

import type {
  Group,
  GroupCreateInput,
  GroupType,
  GroupUpdateInput,
  Institution,
  SchoolYear,
} from '@pta/types';
import { apiCall } from './client';

export function fetchGroup(id: number): Promise<Group> {
  return apiCall(`/groups/${id}`);
}

export function createGroup(input: GroupCreateInput): Promise<Group> {
  return apiCall('/groups', { method: 'POST', body: input });
}

export function updateGroup(id: number, input: GroupUpdateInput): Promise<Group> {
  return apiCall(`/groups/${id}`, { method: 'PATCH', body: input });
}

// -------- A wizard segédlekérdezései --------

export function fetchSchoolYears(countryCode: string): Promise<SchoolYear[]> {
  return apiCall(`/countries/${countryCode}/school-years`);
}

export function fetchGroupTypes(countryCode: string): Promise<GroupType[]> {
  return apiCall(`/countries/${countryCode}/group-types`);
}

/**
 * Egyszerű institution-lista a wizard auto-complete-jéhez. A BE-nek
 * dedikált q-search endpointja nincs; az aktív intézményeket adja egy
 * országra, és a FE-n szűrjük.
 */
export function fetchInstitutionsByCountry(countryCode: string): Promise<Institution[]> {
  return apiCall('/institutions', { query: { country: countryCode, activeOnly: 'true' } });
}
